import React from 'react';
const BotonTerritorios = props => (
  <svg
    width="18"
    height="25"
    viewBox="0 0 18 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.77417 0.5C3.93605 0.5 0 4.50679 0 9.43181C0 12.1867 1.39332 15.5304 4.14137 19.3701C6.1524 22.1802 8.13409 24.1843 8.21748 24.2683C8.37076 24.4226 8.57242 24.5 8.77431 24.5C8.97035 24.5 9.16652 24.427 9.31858 24.2805C9.40216 24.2 11.3889 22.277 13.4037 19.5058C16.154 15.7229 17.5484 12.3336 17.5484 9.43177C17.5483 4.50679 13.6122 0.5 8.77417 0.5ZM8.77417 13.2878C6.40885 13.2878 4.48459 11.3635 4.48459 8.99822C4.48459 6.63295 6.4089 4.70863 8.77417 4.70863C11.1394 4.70863 13.0638 6.63295 13.0638 8.99822C13.0638 11.3635 11.1394 13.2878 8.77417 13.2878Z"
      fill={props.fill}
    />
  </svg>
);

export default BotonTerritorios;
